import axios from "axios";
import AuthService from "../auth/request";

const proyect_id = process.env.VUE_APP_PROYECT_ID

const getCart = () => {
  return new Promise((resolve, reject) => {
  
    let url = '/api/v1/getAllShoppingCar'
    AuthService.getAuthToken().then((response) => {
      axios
        .get(
          url,
          (axios.defaults.headers.common["Authorization"] =
            "Bearer " + response.access_token)
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch(
          error=>{
            if (error.response.status === 401){
        
              localStorage.clear ();
              window.location.reload();
          }
          }
        );
    });
  })
}

const addCart = (id) => {
  return new Promise((resolve, reject) => {
    let url = '/api/v1/addCourseShoppingCard'
    AuthService.getAuthToken().then((response) => {
      axios.defaults.headers.common["Authorization"] = "Bearer " + response.access_token
      axios
        .post(
          url,
          {
            course_id: id,
            proyect_id:  process.env.VUE_APP_PROYECT_ID
          }
        ).then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  })
}

const delCart = (id) => {
  return new Promise((resolve, reject) => {
    let url = '/api/v1/deleteShoppingCar'
    AuthService.getAuthToken().then((response) => {
      axios.defaults.headers.common["Authorization"] = "Bearer " + response.access_token
      axios
        .post(
          url,
          {
            course_id: id,
            proyect_id:  process.env.VUE_APP_PROYECT_ID
          }
        ).then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  })
}

const clearCart = () => {
  return new Promise((resolve, reject) => {
    let url = '/api/v1/clearShoppingCar'
    AuthService.getAuthToken().then((response) => {
      axios.defaults.headers.common["Authorization"] = "Bearer " + response.access_token
      axios
        .post(
          url,
          {
            proyect_id:  process.env.VUE_APP_PROYECT_ID
          }
        ).then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  })
}


export default {
  getCart,
  addCart,
  delCart,
  clearCart
};
